import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';
import { DestinatarioPostModel } from 'model/api/gestao/destinatarios/destinatario-post-model';

export function usePutDestinatarioVarios() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const putDestinatarioVarios = useCallback(
        (destinatario: DestinatarioPostModel[]) =>
            invocarApi({
                url: `/v1/Propaganda/${destinatario[0].propagandaId}/Destinatarios/varios`,
                method: 'PUT',
                data: destinatario,
                baseURL: VariaveisAmbiente.apiPropaganda + '/api',
                enviarTokenUsuario: true,
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        putDestinatarioVarios,
    };
}
